<div *ngIf="logoutReason" class="alert alert-warning alert-dismissible fade show rounded-0 mb-0" role="alert">
  Your account has been suspended. Please contact support for assistance.
  <button type="button" class="btn-close" aria-label="Close" (click)="logoutReason = null"></button>
</div>
<router-outlet></router-outlet>